var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState, useCallback, useRef, useEffect, forwardRef, useImperativeHandle, } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { TextField, Button, MessageBanner } from "@folio/stripes/components";
import styles from "./ScanBar.module.css";
export var ScanBar = forwardRef(function (_a, ref) {
    var onScan = _a.onScan;
    var formatMessage = useIntl().formatMessage;
    var _b = useState(""), isbn = _b[0], setIsbn = _b[1];
    var _c = useState(false), isProcessing = _c[0], setIsProcessing = _c[1];
    var _d = useState(null), feedback = _d[0], setFeedback = _d[1];
    var _e = useState(null), pendingConfirm = _e[0], setPendingConfirm = _e[1];
    var _f = useState(null), offer = _f[0], setOffer = _f[1];
    var inputRef = useRef(null);
    var timerRef = useRef(null);
    var scheduleClearFeedback = useCallback(function () {
        if (timerRef.current)
            clearTimeout(timerRef.current);
        timerRef.current = setTimeout(function () { return setFeedback(null); }, 5000);
    }, []);
    useEffect(function () { return function () {
        if (timerRef.current)
            clearTimeout(timerRef.current);
    }; }, []);
    var focusInput = useCallback(function () {
        var _a;
        (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }, []);
    var applyResult = useCallback(function (result) {
        var _a;
        if (timerRef.current) {
            clearTimeout(timerRef.current);
            timerRef.current = null;
        }
        setPendingConfirm(null);
        setOffer(null);
        if (result.needsConfirmation && result.confirmAction) {
            setFeedback({ type: "warning", message: result.message });
            setPendingConfirm(function () { return result.confirmAction; });
            return;
        }
        if (result.offer) {
            setFeedback({ type: "warning", message: result.message });
            setOffer(result.offer);
            return;
        }
        if (result.silent) {
            setFeedback(null);
            return;
        }
        setFeedback({
            type: (_a = result.variant) !== null && _a !== void 0 ? _a : (result.success ? "success" : "error"),
            message: result.message,
        });
        scheduleClearFeedback();
    }, [scheduleClearFeedback]);
    useImperativeHandle(ref, function () { return ({ showResult: applyResult }); }, [
        applyResult,
    ]);
    var handleScan = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var trimmedIsbn, result, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    trimmedIsbn = isbn.trim();
                    if (!trimmedIsbn || isProcessing)
                        return [2 /*return*/];
                    setIsProcessing(true);
                    setFeedback(null);
                    setOffer(null);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, onScan(trimmedIsbn)];
                case 2:
                    result = _b.sent();
                    applyResult(result);
                    return [3 /*break*/, 5];
                case 3:
                    _a = _b.sent();
                    setFeedback({
                        type: "error",
                        message: formatMessage({
                            id: "ui-br-legaldeposits.enforcement.scan.error",
                        }),
                    });
                    scheduleClearFeedback();
                    return [3 /*break*/, 5];
                case 4:
                    setIsProcessing(false);
                    setIsbn("");
                    focusInput();
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [
        isbn,
        isProcessing,
        onScan,
        applyResult,
        formatMessage,
        scheduleClearFeedback,
        focusInput,
    ]);
    var handleConfirm = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!pendingConfirm)
                        return [2 /*return*/];
                    setIsProcessing(true);
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, 4, 5]);
                    _a = applyResult;
                    return [4 /*yield*/, pendingConfirm()];
                case 2:
                    _a.apply(void 0, [_c.sent()]);
                    return [3 /*break*/, 5];
                case 3:
                    _b = _c.sent();
                    setPendingConfirm(null);
                    setFeedback({
                        type: "error",
                        message: formatMessage({
                            id: "ui-br-legaldeposits.enforcement.scan.error",
                        }),
                    });
                    scheduleClearFeedback();
                    return [3 /*break*/, 5];
                case 4:
                    setIsProcessing(false);
                    focusInput();
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [
        pendingConfirm,
        applyResult,
        formatMessage,
        scheduleClearFeedback,
        focusInput,
    ]);
    var handleCancelConfirm = useCallback(function () {
        setPendingConfirm(null);
        setOffer(null);
        setFeedback(null);
        focusInput();
    }, [focusInput]);
    var handleAcceptOffer = useCallback(function () {
        if (!offer)
            return;
        setOffer(null);
        setFeedback(null);
        offer.onAccept();
    }, [offer]);
    var handleKeyDown = useCallback(function (e) {
        if (e.key === "Enter") {
            e.preventDefault();
            handleScan();
        }
    }, [handleScan]);
    return (React.createElement("div", { className: styles.scanBar },
        React.createElement("div", { className: styles.inputRow },
            React.createElement("div", { className: styles.inputWrapper },
                React.createElement(TextField, { inputRef: inputRef, label: formatMessage({
                        id: "ui-br-legaldeposits.enforcement.scan.label",
                    }), placeholder: formatMessage({
                        id: "ui-br-legaldeposits.enforcement.scan.placeholder",
                    }), value: isbn, onChange: function (e) {
                        return setIsbn(e.target.value);
                    }, onKeyDown: handleKeyDown, autoFocus: true })),
            React.createElement(Button, { buttonStyle: "primary", onClick: handleScan, disabled: !isbn.trim() || isProcessing }, formatMessage({
                id: "ui-br-legaldeposits.enforcement.scan.confirm",
            }))),
        feedback && (React.createElement(MessageBanner, { type: feedback.type }, feedback.message)),
        pendingConfirm && (React.createElement("div", { className: styles.confirmRow },
            React.createElement(Button, { buttonStyle: "primary", onClick: handleConfirm, disabled: isProcessing },
                React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.enforcement.scan.confirmYes" })),
            React.createElement(Button, { onClick: handleCancelConfirm, disabled: isProcessing },
                React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.enforcement.scan.confirmCancel" })))),
        offer && (React.createElement("div", { className: styles.confirmRow },
            React.createElement(Button, { buttonStyle: "primary", onClick: handleAcceptOffer, disabled: isProcessing, "data-test-id": "scan-offer-accept" }, offer.label),
            React.createElement(Button, { onClick: handleCancelConfirm, disabled: isProcessing },
                React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.enforcement.scan.confirmCancel" }))))));
});
ScanBar.displayName = "ScanBar";
